import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "task-content",
  style: { transform: 'translateZ(0)' }
}
const _hoisted_2 = { class: "task-header" }
const _hoisted_3 = { class: "header-buttons" }
const _hoisted_4 = { class: "task-container" }
const _hoisted_5 = { class: "action-bar" }
const _hoisted_6 = { class: "task-form-container" }
const _hoisted_7 = { class: "form-left" }
const _hoisted_8 = { class: "format-toolbar" }
const _hoisted_9 = { class: "form-right" }
const _hoisted_10 = { class: "targets-container" }
const _hoisted_11 = { class: "targets-header" }
const _hoisted_12 = { class: "search-row" }
const _hoisted_13 = { class: "targets-actions" }
const _hoisted_14 = { class: "batch-select" }
const _hoisted_15 = { class: "targets-count" }
const _hoisted_16 = { class: "targets-list" }
const _hoisted_17 = { class: "target-info" }
const _hoisted_18 = { class: "target-name" }
const _hoisted_19 = {
  key: 0,
  class: "target-nickname"
}
const _hoisted_20 = { class: "targets-container" }
const _hoisted_21 = { class: "targets-header" }
const _hoisted_22 = { class: "search-row" }
const _hoisted_23 = { class: "targets-actions" }
const _hoisted_24 = { class: "batch-select" }
const _hoisted_25 = { class: "targets-count" }
const _hoisted_26 = { class: "targets-list" }
const _hoisted_27 = { class: "target-info" }
const _hoisted_28 = { class: "target-name" }
const _hoisted_29 = {
  key: 0,
  class: "target-nickname"
}
const _hoisted_30 = { class: "mb-4" }
const _hoisted_31 = {
  key: 0,
  class: "task-manager-container"
}

import {
  ref,
  computed,
  watch,
  onMounted,
  nextTick,
  onBeforeUnmount,
  h,
  reactive,
} from "vue";
import { useRoute } from "vue-router";
import { message, Modal, Table } from "ant-design-vue";
import type { FormInstance, TableColumnType } from "ant-design-vue";
import {
  DeleteOutlined,
  PlayCircleOutlined,
  FileTextOutlined,
} from "@ant-design/icons-vue";
import { TelegramClient } from "@/websocket/Client";
import TaskDetailManager from "./TaskDetailManager.vue"; // 导入任务管理组件
interface LogItem {
  taskId: number;
  receiver: string;
  sendTime: string;
  errorMsg: string;
  phone: string;
}

// 表格列定义

export default /*@__PURE__*/_defineComponent({
  __name: 'TaskManager',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

const taskDetailManagerVisible = ref(false);
const client = TelegramClient.getInstance();
const account = localStorage.getItem("username") || "";

// 定义日志数据的接口
const columns: TableColumnType[] = [
  {
    title: "任务ID",
    dataIndex: "id",
    key: "id",
    width: 80,
    align: "center",
  },
  {
    title: "任务类型",
    dataIndex: "task_type",
    key: "id",
    width: 80,
    align: "center",
    customRender: ({ text }) => {      
      const typeNum = Number(text);
      switch (typeNum) {
        case 1:
          return "账号发送";
        case 2:
          return "数字ID发送";
        default:
          return `未知类型(${text})`;
      }
    },
  },
  {
    title: "状态",
    dataIndex: "statuss",
    key: "statuss",
    width: 100,
    align: "center",
  },
  {
    title: "发送内容",
    dataIndex: "message",
    key: "message",
    ellipsis: true,
    width: 200,
  },
  {
    title: "发送者",
    dataIndex: "phone",
    key: "phone",
    width: 120,
    align: "center",
  },
  // {
  //   title: "开始时间",
  //   dataIndex: "start_time",
  //   key: "start_time",
  //   width: 160,
  //   align: "center",
  //   customRender: ({ text }) => {
  //     return text ? new Date(text * 1000).toLocaleString() : "-";
  //   },
  // },
  // {
  //   title: "结束时间",
  //   dataIndex: "end_time",
  //   key: "end_time",
  //   width: 160,
  //   align: "center",
  //   customRender: ({ text }) => {
  //     return text ? new Date(text * 1000).toLocaleString() : "-";
  //   },
  // },
  {
    title: "任务间隔(秒)",
    dataIndex: "interval",
    key: "interval",
    width: 120,
    align: "center",
  },
  {
    title: "发送类型",
    dataIndex: "type",
    key: "type",
    width: 120,
    align: "center",
    customRender: ({ text }) => {      
      const typeNum = Number(text);
      switch (typeNum) {
        case 1:
          return "普通发送";
        case 2:
          return "POSTMAN发送";
        default:
          return `未知类型(${text})`;
      }
    },
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 180,
    align: "center",
  },
];

// 数据相关
const visible = ref(true);
const loading = ref(false);
const tasks = ref<any[]>([]);
const selectedRowKeys = ref<number[]>([]);
const modalVisible = ref(false);
const confirmLoading = ref(false);
const formRef = ref<FormInstance>();

// 表单相关
const taskForm = ref<{
  phone: string[];
  message: string;
  targets: string[];
  targetIds: string[];
  startTime: Date | null;
  endTime: Date | null;
  interval: number | null;
  type: number;
}>({
  phone: [],
  message: "",
  targets: [],
  targetIds: [],
  startTime: null,
  endTime: null,
  interval: null,
  type: 1,
});

// 添加新的 ref 用于存储发送者列表
const phoneList = ref<string[]>([]);

// 获取发送者列表
const fetchPhoneList = async () => {
  try {
    const response = await client.getAccountList(account);
    if (response && response.list) {
      //console.log("获取发送者列表", response);
      phoneList.value = response.list.map((item: any) => item.strAccount);
    }
  } catch (error) {
    message.error("获取发送者列表失败");
  }
};

// 添加新的 ref 用于存储接收者列表
const targetsList = ref<any[]>([]);

const targetIdsList = ref<any[]>([]);

const rules = {
  phone: [{ required: true, message: "请输入发送者", trigger: "blur" }],
  message: [{ required: true, message: "请输入发送内容", trigger: "blur" }],
  targets: [{ required: true, message: "请选择接收者", trigger: "change" }],
  interval: [{ required: true, message: "请输入间隔时间", trigger: "change" }],
  type: [{ required: true, message: "请选择任务类型", trigger: "change" }],
};

// 接收父组件传入的 visible prop
const props = __props;

const emit = __emit;

// 使用计算属性处理 visible 状态
const isOpen = computed({
  get: () => props.visible,
  set: (value) => emit("update:visible", value),
});

// 监听可见性变化
watch(
  () => props.visible,
  (newVisible) => {
    if (newVisible) {
      console.log("任务管理页面显示，获取任务列表");
      fetchTasks();
    }
  }
);

// 处理关闭
const handleClose = () => {
  emit("update:visible", false);
};

// 获取任务列表
const fetchTasks = async () => {
  try {
    loading.value = true;
    const response = await client.getTaskList(account);
    console.log("获取任务列表", response);

    // 修改这部分逻辑，确保在没有数据时将任务列表清空
    if (response && response.list) {
      tasks.value = response.list.map((item) => ({
        id: item.index,
        statuss: item.status,
        message: item.message,
        task_type: item.task_type,
        type: item.msg_type,
        start_time: item.start_time,
        end_time: item.end_time,
        interval: item.interval,
        created_at: item.create_time,
        taskId: item.index,
        phone: item.phone,
        targets: item.targets,
      }));
    } else {
      // 如果response为undefined或没有list属性，将任务列表清空
      tasks.value = [];
    }
  } catch (error) {
    message.error("获取任务列表失败");
    // 发生错误时也清空任务列表
    tasks.value = [];
  } finally {
    loading.value = false;
  }
};

// 删除任务
const handleDelete = async (taskId: number) => {
  Modal.confirm({
    title: "确认删除",
    content: "确定要删除该任务吗？",
    async onOk() {
      try {
        const response = await client.deleteTask(account, [taskId]);
        if (response.code === 1) {
          message.success(response.reason);
          fetchTasks();
        } else {
          message.error(response.reason || "删除失败");
        }
      } catch (error) {
        message.error("删除失败");
      }
    },
  });
};

// 定义 rowSelection 为计算属性以确保响应性
const rowSelection = computed(() => ({
  selectedRowKeys: selectedRowKeys.value,
  onChange: (selectedKeys: number[]) => {
    selectedRowKeys.value = selectedKeys;
  },
  onSelect: (record: any, selected: boolean) => {
    console.log("选择单行:", record, selected);
  },
  onSelectAll: (selected: boolean, selectedRows: any[], changeRows: any[]) => {
    console.log("全选切换:", selected, selectedRows.length);
  },
}));

// 批量删除方法
const handleBatchDelete = async () => {
  if (!selectedRowKeys.value.length) return;

  Modal.confirm({
    title: "确认删除",
    content: `是否确认删除选中的 ${selectedRowKeys.value.length} 条记录？`,
    async onOk() {
      try {
        // 调用 client.deleteTask 方法删除选中的任务
        const response = await client.deleteTask(
          account,
          selectedRowKeys.value
        );
        if (response.code === 1) {
          message.success(response.reason || "删除成功");
          // 刷新列表
          await fetchTasks();
          // 清空选择
          selectedRowKeys.value = [];

        } else {
          message.error(response.reason || "删除失败");
        }
      } catch (error) {
        console.error("批量删除失败:", error);
        message.error("删除失败");
      }
    },
  });
};


// 显示任务模态框方法
const showTaskDetailModal = () => {
  taskDetailManagerVisible.value = true;
};

// 修改执行任务的处理函数
const handleExecute = async (taskIds: number[]) => {
  showTaskDetailModal();
  try {
    const response = await client.executeTask(account, taskIds);
    console.log(response);
    if (response.code === 1) {
      console.log(response.reason);
      message.success(response.reason || "任务执行成功");
      fetchTasks();
      // 清空选择
      selectedRowKeys.value = [];
    } else {
      console.log(response.reason);
      message.error(response.reason || "任务执行失败");
    }
  } catch (error) {
    message.error("任务执行失败");
  }
};

// 添加响应式变量
const logModalVisible = ref(false);
const logData = ref<any[]>([]);
const currentTaskId = ref<number>();

const handleViewLog = async (taskId: number) => {
  try {
    const response = await client.getTaskLog(account, [taskId]);
    console.log("获取任务日志", response);
    if (response.code === 1) {
      Modal.info({
        title: '任务日志',
        width: 1000,
        content: h('div', 
          { 
            style: 'max-height: 500px; overflow-y: auto;'
          },
          [
            // 表头
            h('div', 
              { 
                style: 'display: grid; grid-template-columns: repeat(4, 1fr); padding: 8px; background-color: #f5f5f5; font-weight: bold; text-align: center; border-bottom: 1px solid #e8e8e8;'
              },
              [
                h('div', null, '接收者'),
                h('div', null, '发送时间'),
                h('div', null, '状态'),
                h('div', null, '手机号'),
              ]
            ),
            // 数据行
            ...response.list.map((item, index) => 
              h('div', 
                { 
                  key: index,
                  style: 'display: grid; grid-template-columns: repeat(4, 1fr); padding: 8px; text-align: center; border-bottom: 1px solid #e8e8e8;'
                },
                [
                  h('div', null, item.receiver),
                  h('div', null, new Date(Number(item.sendTime) * 1000).toLocaleString()),
                  h('div', null, [
                    h('span', 
                      { 
                        style: `color: ${item.errorMsg === '发送成功' ? '#52c41a' : '#ff4d4f'}`
                      }, 
                      item.errorMsg
                    )
                  ]),
                  h('div', null, item.phone)
                ]
              )
            )
          ]
        ),
        okText: '关闭'
      });
    } else {
      message.error(response.reason || '获取日志失败');
    }
  } catch (error) {
    message.error('获取日志失败');
  }
};

const taskManagerRef = ref<HTMLElement | null>(null);
let resizeObserver: ResizeObserver | null = null;

// 防抖函数
const debounce = (fn: Function, delay: number) => {
  let timer: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

// 处理 ResizeObserver 的回调
const handleResize = debounce((entries: ResizeObserverEntry[]) => {
  for (const entry of entries) {
    // 只在真正需要处理尺寸变化时执行相关逻辑
    if (entry.target === taskManagerRef.value) {
      // 这里可以添加必要的尺寸调整逻辑
      console.debug("TaskManager size changed");
    }
  }
}, 100); // 100ms 的防抖延迟

onMounted(async () => {
  await nextTick();

  // 创建 ResizeObserver 实例
  resizeObserver = new ResizeObserver((entries) => {
    window.requestAnimationFrame(() => {
      handleResize(entries);
    });
  });

  // 只观察主容器元素
  if (taskManagerRef.value) {
    resizeObserver.observe(taskManagerRef.value);
  }

  // 错误处理
  const ignoreResizeObserverError = (error: ErrorEvent) => {
    if (error.message.includes("ResizeObserver")) {
      error.stopPropagation();
      return true;
    }
  };

  window.addEventListener("error", ignoreResizeObserverError);

  // 清理函数
  onBeforeUnmount(() => {
    window.removeEventListener("error", ignoreResizeObserverError);

    // 停止观察并断开连接
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  });

  console.log("TaskManager组件已挂载");
  fetchTasks();
  fetchPhoneList();
});

// 添加新的 ref
const addTaskModalVisible = ref(false);
const addTaskFormRef = ref<FormInstance>();

// 显示新增任务弹窗
const showAddTaskModal = async () => {
  try {
    // 打开弹窗前获取接收者列表
    console.log("当前账号:", account);
    const response = await client.getPrivateChatList(account, "session", 2);
    console.log("获取接收者列表:", response);

    // 添加对空数据的处理
    if (response && Array.isArray(response) && response.length > 0) {
      targetsList.value = response.filter((value) => value.strAccount != "").map((receiver) => ({
        id: receiver.strTelegramNo,
        name: receiver.strAccount,
        nickname: receiver.strNickName,
      }));

      targetIdsList.value = response.filter((value) => value.strTelegramNo != "").map((receiver) => ({
        id: receiver.strTelegramNo,
        name: receiver.strTelegramNo,
        nickname: receiver.strNickName,
      }));
      console.log("111");
      let list =  targetIdsList.value;
      console.log("222");

    } else {
      // 确保targetsList为空数组而不是undefined
      targetsList.value = [];
      targetIdsList.value = [];
      message.warning("暂无可用的接收者列表");
    }

    // 无论是否有数据都显示弹窗
    addTaskModalVisible.value = true;
  } catch (error) {
    console.error("获取接收者列表出错:", error);
    message.error("获取接收者列表失败");
    // 发生错误时也确保targetsList为空数组
    targetsList.value = [];
    // 错误时仍然显示弹窗
    addTaskModalVisible.value = true;
  }
};

// 处理新增任务
const handleAddTask = async () => {
  console.log("handleAddTask");
  try {
    await addTaskFormRef.value?.validate();
    confirmLoading.value = true;

    // 直接使用选择的用户名，不需要再查找
    const targets = taskForm.value.targets.map(name => ({ name }));
 
    const taskData = {
      task_type:1,
      phones: taskForm.value.phone,
      targets: targets,
      msg_type: Number(taskForm.value.type),
      message: taskForm.value.message,
      start_time: taskForm.value.startTime
        ? Math.floor(+taskForm.value.startTime / 1000)
        : 0,
      end_time: taskForm.value.endTime
        ? Math.floor(+taskForm.value.endTime / 1000)
        : 0,
      interval: taskForm.value.interval || 0,
      remark: "",
    };

    const response = await client.createTask(account, taskData);

    if (response.code === 1) {
      message.success("创建任务成功");
      fetchTasks();
      Modal.success({
        title: "任务创建结果",
        content: response.reason || "任务创建成功",
        onOk: () => {
          addTaskModalVisible.value = false;
          // 重置表单
          taskForm.value = {
            phone: [],
            message: "",
            targets: [],
            targetIds: [],
            startTime: null,
            endTime: null,
            interval: null,
            type: 1,
          };
        },
      });
    } else {
      message.error(response.reason || "创建任务失败");
    }
  } catch (error) {
    console.error("创建任务失败:", error);
    message.error("表单验证失败或创建任务失败");
  } finally {
    confirmLoading.value = false;
  }
};


// 处理新增任务
const handleAddTaskID = async () => {
  console.log("handleAddTaskID");
  try {
    await addTaskFormRef.value?.validate();
    confirmLoading.value = true;

    // 直接使用选择的用户名，不需要再查找
    const targets = taskForm.value.targetIds.map(name => ({ name }));
 
    const taskData = {
      task_type:2,
      phones: taskForm.value.phone,
      targets: targets,
      msg_type: Number(taskForm.value.type),
      message: taskForm.value.message,
      start_time: taskForm.value.startTime
        ? Math.floor(+taskForm.value.startTime / 1000)
        : 0,
      end_time: taskForm.value.endTime
        ? Math.floor(+taskForm.value.endTime / 1000)
        : 0,
      interval: taskForm.value.interval || 0,
      remark: "",
    };

    const response = await client.createTask(account, taskData);

    if (response.code === 1) {
      message.success("创建任务成功");
      fetchTasks();
      Modal.success({
        title: "任务创建结果",
        content: response.reason || "任务创建成功",
        onOk: () => {
          addTaskModalVisible.value = false;
          // 重置表单
          taskForm.value = {
            phone: [],
            message: "",
            targets: [],
            targetIds: [],
            startTime: null,
            endTime: null,
            interval: null,
            type: 1,
          };
        },
      });
    } else {
      message.error(response.reason || "创建任务失败");
    }
  } catch (error) {
    console.error("创建任务失败:", error);
    message.error("表单验证失败或创建任务失败");
  } finally {
    confirmLoading.value = false;
  }
};



// 处理取消添加任务
const handleAddTaskCancel = () => {
  addTaskModalVisible.value = false;
  taskForm.value = {
    phone: [],
    message: "",
    targets: [],
    targetIds: [],
    startTime: null,
    endTime: null,
    interval: null,
    type: 1,
  };

  console.log("fasdfas");

};

// 转换发送者列表为 Select 组件需要的格式
const phoneOptions = computed(() => {
  return phoneList.value.map((phone) => ({
    value: phone,
    label: phone,
  }));
});

// 添加发送者选择处理函数
const handlePhoneChange = (value: string[]) => {
  console.log("选择的发送者:", value);
  taskForm.value.phone = value;
};

const searchText = ref("");
const searchId = ref("");
// 过滤接收者列表
const filteredTargets = computed(() => {
  if (!searchText.value) return targetsList.value;
  const search = searchText.value.toLowerCase();
  return targetsList.value.filter(
    (target) =>
      target.name.toLowerCase().includes(search) ||
      (target.nickname && target.nickname.toLowerCase().includes(search))
  );
});

const onSearch = (value: string) => {
  searchText.value = value;
};


// 过滤接收者列表
const filteredTargetIds = computed(() => {
  if (!searchId.value) return targetIdsList.value;
  const search = searchId.value.toLowerCase();
  return targetIdsList.value.filter(
    (target) =>
      target.name.toLowerCase().includes(search) ||
      (target.nickname && target.nickname.toLowerCase().includes(search))
  );
});

const onSearchID = (value: string) => {
  searchId.value = value;
};


const handleBatchSelect = () => {
  // 获取当前过滤后的列表
  const currentList = filteredTargets.value;
  var count = currentList.length;
  // 使用 name 而不是 id
  const newTargets = currentList
    .slice(0, count)
    .map((target) => target.name);

  // 更新选择
  taskForm.value.targets = newTargets;
};

const handleClearSelection = () => {
  // 清空选择
  taskForm.value.targets = [];
};


const handleBatchSelectId = () => {
  // 获取当前过滤后的列表
  const currentList = filteredTargetIds.value;
  var count = currentList.length;
  // 使用 name 而不是 id
  const newTargets = currentList
    .slice(0, count)
    .map((target) => target.name);

  // 更新选择
  taskForm.value.targetIds = newTargets;
};

const handleClearSelectionId = () => {
  // 清空选择
  taskForm.value.targetIds = [];
};



const getStatusColor = (status: number) => {
  switch (status) {
    case 1:
      return 'blue';    // 待执行
    case 2:
      return 'orange';  // 执行中
    case 3:
      return 'green';   // 执行完毕
    default:
      return 'default';
  }
};

const getStatusText = (status: number) => {
  switch (status) {
    case 1:
      return '待执行';
    case 2:
      return '执行中';
    case 3:
      return '执行完毕';
    default:
      return '未知状态';
  }
};

// 添加链接编辑对话框的状态
const linkModalVisible = ref(false);
const linkForm = reactive({
  text: '',
  url: ''
});

// 添加文本格式化方法
const formatText = {
  bold: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`*${selected}*`, start, end);
  },

  italic: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`_${selected}_`, start, end);
  },

  underline: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`__${selected}__`, start, end);
  },

  strikethrough: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`~${selected}~`, start, end);
  },

  code: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`${selected}\``, start, end);
  },

  codeblock: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`\`\`\n${selected}\n\`\`\``, start, end);
  },

  spoiler: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`||${selected}||`, start, end);
  },

  quote: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    const formatted = selected.split('\n').map(line => `> ${line}`).join('\n');
    insertText(formatted, start, end);
  },

  link: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const text = textarea.value;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    linkForm.text = text.substring(start, end);
    linkForm.url = '';
    
    const currentPos = { start, end };
    (textarea as any).savedPos = currentPos;
    
    linkModalVisible.value = true;
  }
};

// 辅助函数：插入文本
const insertText = (newText: string, start: number, end: number) => {
  const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const text = textarea.value;
  taskForm.value.message = text.substring(0, start) + newText + text.substring(end);
  
  textarea.focus();
  const newPosition = start + newText.length;
  textarea.setSelectionRange(newPosition, newPosition);
};

// 处理链接确认
const handleLinkConfirm = () => {
  const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const { start, end } = (textarea as any).savedPos || { start: 0, end: 0 };
  const linkMarkdown = `[${linkForm.text}](${linkForm.url})`;
  
  insertText(linkMarkdown, start, end);
  linkModalVisible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button_group = _resolveComponent("a-button-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "task-manager",
      ref_key: "taskManagerRef",
      ref: taskManagerRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[21] || (_cache[21] = _createElementVNode("h2", null, "任务管理", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: showAddTaskModal
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [
                _createTextVNode("新增任务")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: handleClose
            }, {
              default: _withCtx(() => _cache[20] || (_cache[20] = [
                _createTextVNode("返回")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  disabled: !selectedRowKeys.value.length,
                  onClick: _cache[0] || (_cache[0] = () => handleExecute(selectedRowKeys.value))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(PlayCircleOutlined))
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" 批量执行 (" + _toDisplayString(selectedRowKeys.value.length) + ") ", 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  danger: "",
                  disabled: !selectedRowKeys.value.length,
                  onClick: handleBatchDelete,
                  class: "delete-btn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DeleteOutlined)),
                    _createTextVNode("批量删除 (" + _toDisplayString(selectedRowKeys.value.length) + ") ", 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_a_table, {
            loading: loading.value,
            columns: columns,
            "data-source": tasks.value,
            "row-selection": rowSelection.value,
            pagination: {
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条`,
            size: 'default',
          },
            scroll: { x: '100%' },
            "row-key": "id",
            bordered: "",
            class: "custom-table"
          }, {
            bodyCell: _withCtx(({ column, record }) => [
              (column.key === 'action')
                ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_a_button, {
                        type: "primary",
                        size: "small",
                        onClick: ($event: any) => (handleViewLog(record.taskId))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(FileTextOutlined))
                        ]),
                        default: _withCtx(() => [
                          _cache[22] || (_cache[22] = _createTextVNode(" 查看日志 "))
                        ]),
                        _: 2
                      }, 1032, ["onClick"]), [
                        [_vShow, false]
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : (column.key === 'statuss')
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 1,
                      color: getStatusColor(record.statuss)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getStatusText(record.statuss)), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading", "data-source", "row-selection", "pagination"])
        ]),
        _createVNode(_component_a_modal, {
          visible: addTaskModalVisible.value,
          "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((addTaskModalVisible).value = $event)),
          title: "新增任务",
          onOk: handleAddTask,
          onCancel: handleAddTaskCancel,
          confirmLoading: confirmLoading.value,
          okText: "增加",
          cancelText: "取消",
          width: "900px"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_a_button, {
              key: "back",
              onClick: handleAddTaskCancel
            }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              key: "submit",
              type: "primary",
              onClick: handleAddTask
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [
                _createTextVNode("增加(账号)")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              key: "submit",
              type: "primary",
              onClick: handleAddTaskID
            }, {
              default: _withCtx(() => _cache[25] || (_cache[25] = [
                _createTextVNode("增加(ID)")
              ])),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_a_form, {
                  ref_key: "addTaskFormRef",
                  ref: addTaskFormRef,
                  model: taskForm.value,
                  rules: rules,
                  "label-col": { span: 6 },
                  "wrapper-col": { span: 16 }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "发送者",
                      name: "phone"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: taskForm.value.phone,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((taskForm.value.phone) = $event)),
                          mode: "multiple",
                          placeholder: "请选择发送者",
                          onChange: handlePhoneChange,
                          options: phoneOptions.value
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "发送内容",
                      name: "message"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_a_button_group, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                onClick: formatText.bold,
                                title: "粗体"
                              }, {
                                default: _withCtx(() => _cache[26] || (_cache[26] = [
                                  _createTextVNode("B")
                                ])),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_a_button, {
                                onClick: formatText.italic,
                                title: "斜体"
                              }, {
                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                  _createTextVNode("I")
                                ])),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_a_button, {
                                onClick: formatText.underline,
                                title: "下划线"
                              }, {
                                default: _withCtx(() => _cache[28] || (_cache[28] = [
                                  _createTextVNode("U")
                                ])),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_a_button, {
                                onClick: formatText.strikethrough,
                                title: "删除线"
                              }, {
                                default: _withCtx(() => _cache[29] || (_cache[29] = [
                                  _createTextVNode("S")
                                ])),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_a_button, {
                                onClick: formatText.code,
                                title: "行内代码"
                              }, {
                                default: _withCtx(() => _cache[30] || (_cache[30] = [
                                  _createTextVNode("{}")
                                ])),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_a_button, {
                                onClick: formatText.codeblock,
                                title: "代码块"
                              }, {
                                default: _withCtx(() => _cache[31] || (_cache[31] = [
                                  _createTextVNode("{ }")
                                ])),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_a_button, {
                                onClick: formatText.link,
                                title: "添加链接"
                              }, {
                                default: _withCtx(() => _cache[32] || (_cache[32] = [
                                  _createTextVNode("🔗")
                                ])),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_a_button, {
                                onClick: formatText.spoiler,
                                title: "隐藏文本"
                              }, {
                                default: _withCtx(() => _cache[33] || (_cache[33] = [
                                  _createTextVNode("⊟")
                                ])),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_a_button, {
                                onClick: formatText.quote,
                                title: "引用"
                              }, {
                                default: _withCtx(() => _cache[34] || (_cache[34] = [
                                  _createTextVNode("\"")
                                ])),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_a_textarea, {
                          value: taskForm.value.message,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((taskForm.value.message) = $event)),
                          placeholder: "请输入发送内容",
                          rows: 4
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "开始时间",
                      name: "startTime"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_date_picker, {
                          value: taskForm.value.startTime,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((taskForm.value.startTime) = $event)),
                          "show-time": true,
                          format: "YYYY-MM-DD HH:mm:ss",
                          placeholder: "选择开始时间",
                          style: {"width":"100%"}
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "结束时间",
                      name: "endTime"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_date_picker, {
                          value: taskForm.value.endTime,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((taskForm.value.endTime) = $event)),
                          "show-time": true,
                          format: "YYYY-MM-DD HH:mm:ss",
                          placeholder: "选择结束时间",
                          style: {"width":"100%"}
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "间隔时间(秒)",
                      name: "interval"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_number, {
                          value: taskForm.value.interval,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((taskForm.value.interval) = $event)),
                          min: 5,
                          placeholder: "请输入间隔时间",
                          style: {"width":"100%"}
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "发送类型",
                      name: "type"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: taskForm.value.type,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((taskForm.value.type) = $event)),
                          placeholder: "请选择发送类型"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: 1 }, {
                              default: _withCtx(() => _cache[35] || (_cache[35] = [
                                _createTextVNode("普通发送")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: 2 }, {
                              default: _withCtx(() => _cache[36] || (_cache[36] = [
                                _createTextVNode("POSTMAN发送")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_a_form_item, {
                  label: "接收者(账号)",
                  name: "targets",
                  class: "targets-form-item"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_input_search, {
                            value: searchText.value,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((searchText).value = $event)),
                            placeholder: "搜索接收者",
                            onSearch: onSearch,
                            style: {"width":"100%"}
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_a_button, {
                              size: "small",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (handleBatchSelect()))
                            }, {
                              default: _withCtx(() => _cache[37] || (_cache[37] = [
                                _createTextVNode("全选")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_a_button, {
                              size: "small",
                              onClick: handleClearSelection
                            }, {
                              default: _withCtx(() => _cache[38] || (_cache[38] = [
                                _createTextVNode("清空")
                              ])),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_15, " 已选择: " + _toDisplayString(taskForm.value.targets.length) + " 个接收者 ", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_a_checkbox_group, {
                          value: taskForm.value.targets,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((taskForm.value.targets) = $event)),
                          class: "targets-checkbox-group"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTargets.value, (target) => {
                              return (_openBlock(), _createBlock(_component_a_checkbox, {
                                key: target.id,
                                value: target.name,
                                class: "target-item"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("span", _hoisted_18, _toDisplayString(target.name), 1),
                                    (target.nickname)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, " (" + _toDisplayString(target.nickname) + ") ", 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "接收者(ID)",
                  name: "targets",
                  class: "targets-form-item"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_a_input_search, {
                            value: searchId.value,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((searchId).value = $event)),
                            placeholder: "搜索接收者",
                            onSearch: onSearchID,
                            style: {"width":"100%"}
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_a_button, {
                              size: "small",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (handleBatchSelectId()))
                            }, {
                              default: _withCtx(() => _cache[39] || (_cache[39] = [
                                _createTextVNode("全选")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_a_button, {
                              size: "small",
                              onClick: handleClearSelectionId
                            }, {
                              default: _withCtx(() => _cache[40] || (_cache[40] = [
                                _createTextVNode("清空")
                              ])),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_25, " 已选择: " + _toDisplayString(taskForm.value.targetIds.length) + " 个接收者 ", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_a_checkbox_group, {
                          value: taskForm.value.targetIds,
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((taskForm.value.targetIds) = $event)),
                          class: "targets-checkbox-group"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTargetIds.value, (target) => {
                              return (_openBlock(), _createBlock(_component_a_checkbox, {
                                key: target.id,
                                value: target.name,
                                class: "target-item"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("span", _hoisted_28, _toDisplayString(target.name), 1),
                                    (target.nickname)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, " (" + _toDisplayString(target.nickname) + ") ", 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible", "confirmLoading"]),
        _createVNode(_component_a_modal, {
          visible: logModalVisible.value,
          "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((logModalVisible).value = $event)),
          title: "任务日志",
          footer: null,
          width: "800px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_30, "任务ID: " + _toDisplayString(currentTaskId.value), 1),
            _createVNode(_component_a_table, {
              columns: columns,
              "data-source": logData.value,
              pagination: false,
              bordered: ""
            }, null, 8, ["data-source"])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_a_modal, {
          visible: linkModalVisible.value,
          "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((linkModalVisible).value = $event)),
          title: "添加链接",
          onOk: handleLinkConfirm,
          okText: "确定",
          cancelText: "取消"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              model: linkForm,
              layout: "vertical"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "链接文字" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: linkForm.text,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((linkForm.text) = $event)),
                      placeholder: "请输入链接显示的文字"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "链接地址" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: linkForm.url,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((linkForm.url) = $event)),
                      placeholder: "请输入链接地址"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ], 512),
    (taskDetailManagerVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createVNode(TaskDetailManager, {
            visible: taskDetailManagerVisible.value,
            "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((taskDetailManagerVisible).value = $event))
          }, null, 8, ["visible"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})